/* eslint-disable prefer-destructuring, no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Professor from '@/assets/images/exercises/matchUp/professor.png';
import Trumpet from '@/assets/images/exercises/matchUp/trumpet.png';
import GreenBtn from '@/assets/images/exercises/matchUp/green_dot.png';
import { matchUpSounds } from '@/utils/sounds';
import './style.less';

let card = null;

class MatchUp extends Component {
  static propTypes = {
    finished: PropTypes.func,
    exercisesData: PropTypes.object,
    url: PropTypes.string,
    audioPlay: PropTypes.func,
    matchType: PropTypes.string,
    layout: PropTypes.string,
    soundsUrl: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      matchData: null,
    };
  }

  componentDidMount() {
    const { exercisesData, url, matchType } = this.props;
    this.init(exercisesData, url, matchType);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.url !== this.props.url
      && this.setState({ matchData: null }, () => {
        this.init(nextProps.exercisesData, nextProps.url, nextProps.matchType);
      });
  }

  init = (exercisesData, url, matchType) => {
    const { soundsUrl } = this.props;
    card = {
      prevVal: '',
      naxtVal: '',
      nextId: '',
      prevId: '',
      rightNum: 0,
    };
    const match = exercisesData.root[0].tasks[0].task[0].matches[0].match;
    const target = exercisesData.root[0].tasks[0].task[0].targets[0].target;
    const Data = [];
    target.forEach((item, index) => {
      if (item._attr.img) {
        Data.push({
          questionType: 'img',
          type: 'question',
          img: `${url}${item._attr.img._value}`,
          txt: '',
          audio: `${soundsUrl}${matchUpSounds.handle}`,
          val: index + 1,
          class: '',
        });
        Data.push({
          questionType: 'img',
          type: 'answer',
          img: '',
          txt: match[index]._attr.text._value,
          audio: `${url}OM/${match[index]._attr.audio._value}.ogg`,
          val: index + 1,
          class: '',
        });
      } else if (matchType === 'Audio') {
        Data.push({
          questionType: 'audio',
          type: 'question',
          img: '',
          txt: item._attr.text._value,
          audio: `${url}OM/${item._attr.audio._value}.ogg`,
          val: index,
          word: match[index]._attr.text._value,
          class: '',
        });
        Data.push({
          questionType: 'audio',
          type: 'answer',
          img: '',
          txt: match[index]._attr.text._value,
          audio: `${url}OM/${match[index]._attr.audio._value}.ogg`,
          val: index,
          word: '',
          class: '',
        });
      } else if (matchType === 'TextAudio') {
        Data.push({
          questionType: 'textAudio',
          type: 'question',
          img: '',
          txt: item._attr.text._value,
          audio: `${url}OM/${item._attr.audio._value}.ogg`,
          val: index,
          word: match[index]._attr.text._value,
          class: '',
        });
        Data.push({
          questionType: 'textAudio',
          type: 'answer',
          img: '',
          txt: match[index]._attr.text._value,
          audio: `${url}OM/${match[index]._attr.audio._value}.ogg`,
          val: index,
          word: '',
          class: '',
        });
      } else if (matchType === 'Text') {
        Data.push({
          questionType: 'text',
          type: 'question',
          url: '',
          txt: item._attr.text._value,
          audio: `${soundsUrl}${matchUpSounds.handle}`,
          val: index,
          class: '',
        });
        Data.push({
          questionType: 'text',
          type: 'answer',
          url: '',
          txt: match[index]._attr.text._value,
          audio: `${soundsUrl}${matchUpSounds.handle}`,
          val: index,
          class: '',
        });
      }
    });
    this.arrRandom(Data);
    this.setState({
      matchData: Data,
    });
  }

  handleClick = (e, i) => {
    e.preventDefault();
    e.stopPropagation();
    const { matchData } = this.state;
    console.log(matchData);
    if (matchData[i].class !== 'rotate' && !card.nextVal) {
      if (document.querySelectorAll('.rotate').length % 2 === 1) {
        card.nextVal = matchData[i].val + 1;
        matchData[i].class = 'rotate';
        card.nextId = i;
        // 没有音频动画完成直接匹配
        matchData[i].audio.includes('Library/sounds/') && e.currentTarget.addEventListener('transitionend', this.handleMatchUp);
      } else {
        card.prevVal = matchData[i].val + 1;
        matchData[i].class = 'rotate';
        card.prevId = i;
      }
      !(matchData[i].audio.includes('Library/sounds/')) && (document.querySelector('.card-modal').className = 'card-modal block');
      this.handlePlay(matchData[i].audio);
      this.setState({ matchData });
    }
  }

  handleMatchUp = () => {
    const { matchData } = this.state;
    const { soundsUrl } = this.props;
    document.querySelector('.card-modal').className = 'card-modal';
    if (card.prevVal && card.nextVal) {
      if (card.prevVal !== card.nextVal) {
        matchData[card.prevId].class = '';
        matchData[card.nextId].class = '';
        this.handlePlay(`${soundsUrl}${matchUpSounds.wrong}`);
        document.getElementById(`li${card.nextId}`).removeEventListener('transitionend', this.handleMatchUp);
      } else {
        matchData[card.prevId].class += ' right';
        matchData[card.nextId].class += ' right';
        card.rightNum += 1;
        if (card.rightNum === 4) {
          this.handlePlay(`${soundsUrl}${matchUpSounds.allRight}`);
          this.props.finished();
        } else {
          this.handlePlay(`${soundsUrl}${matchUpSounds.right}`);
        }
      }
      card.prevVal = '';
      card.nextVal = '';
      this.setState({ matchData });
    }
  }

  handleGreenBtnPlay = (e, src) => {
    e.preventDefault();
    e.stopPropagation();
    this.handlePlay(src);
  }

  handlePlay = (src) => {
    this.props.audioPlay(src, { type: 'exercise' });
    !src.includes('Library/sounds/') && document.querySelector('.exercises_modal') !== null && (document.querySelector('.exercises_modal').className = 'exercises_modal block');
  }

  audioEnd = () => {
    this.handleMatchUp();
    document.querySelector('.exercises_modal') !== null && (document.querySelector('.exercises_modal').className = 'exercises_modal');
  }

  audioPlay = () => null

  arrRandom = (Data) => {
    const arr = Data;
    arr.sort(() => Math.random() - 0.5);
  }

  render = () => {
    const { matchData } = this.state;
    const { layout } = this.props;
    return (
      <div className="match-up-container">
        <div className="card-modal" />
        {matchData
          && (
            <ul>
              {
                matchData.map((item, index) => (
                  <li
                    key={`li${index + 1}`}
                    className={item.class}
                    id={`li${index}`}
                    onClick={(e) => { !item.class && this.handleClick(e, index); }}
                  >
                    <div
                      className="card-back"
                    >
                      {
                        item.questionType === 'img' && item.type === 'question'
                        && <img className="pic-cover" src={item.img} alt="" />
                      }
                      {
                        item.questionType === 'img' && item.type !== 'question'
                        && <img className="green-btn" src={GreenBtn} alt="" onClick={(e) => { this.handleGreenBtnPlay(e, item.audio); }} />
                      }
                      {
                        item.questionType === 'img' && item.type !== 'question'
                        && <span style={{ marginLeft: '24px' }} className={item.txt.indexOf(' ') !== -1 ? 'sentence1' : 'word2'}>{item.txt}</span>
                      }
                      {
                        item.questionType === 'audio' && item.type === 'question'
                        && <img className="green-btn" src={GreenBtn} alt="" onClick={(e) => { this.handleGreenBtnPlay(e, item.audio); }} />
                      }
                      {
                        item.questionType === 'audio' && item.type === 'question'
                        && item.txt.split('').map((letter, i) => (
                          <span
                            key={`span${i + 1}`}
                            className={`word2 ${`${item.txt.toLowerCase().indexOf(item.word.toLowerCase())},${item.txt.toLowerCase().indexOf(item.word.toLowerCase()) + item.word.length - 1}`.includes(i) ? 'bottom' : ''}`}
                            style={{ marginLeft: i === 0 ? '24px' : '' }}
                          >
                            {letter}
                          </span>
                        ))
                      }
                      {
                        item.questionType === 'audio' && item.type !== 'question'
                        && <img className="trumpet" src={Trumpet} alt="" />
                      }
                      {
                        item.questionType === 'textAudio'
                        && <img className="green-btn" src={GreenBtn} alt="" onClick={(e) => { this.handleGreenBtnPlay(e, item.audio); }} />
                      }
                      {
                        item.questionType === 'textAudio'
                        && <span style={{ marginLeft: '14px' }} className={item.txt.indexOf(' ') !== -1 ? 'sentence2' : 'word2'}>{item.txt}</span>
                      }
                      {
                        item.questionType === 'text' && item.type === 'question' && layout === 'causes' && <div className="before">Cause:</div>
                      }
                      {
                        item.questionType === 'text' && item.type !== 'question' && layout === 'causes' && <div className="before">Effect:</div>
                      }
                      {
                        item.questionType === 'text' && item.type === 'question' && layout === 'solutions' && <div className="before">Problem:</div>
                      }
                      {
                        item.questionType === 'text' && item.type !== 'question' && layout === 'solutions' && <div className="before">Solution:</div>
                      }
                      {
                        item.questionType === 'text' && item.type === 'question'
                        && <span className={item.txt.indexOf(' ') !== -1 ? 'sentence2' : 'word2'}>{item.txt}</span>
                      }
                      {
                        item.questionType === 'text' && item.type !== 'question'
                        && <span className={item.txt.indexOf(' ') !== -1 ? 'sentence2' : 'word2'}>{item.txt}</span>
                      }
                    </div>
                    <div className="card-front">
                      <img src={Professor} alt="" />
                    </div>
                  </li>
                ))
              }
            </ul>
          )
        }
      </div>
    );
  }
}

export default MatchUp;
